import { Suspense, lazy } from 'react';
import { useVersionStore } from '../../store/sceneStore';
import { useUpdateLiveData } from '../../interpreter/hooks';
import useSoundManager from '../../interpreter/hooks/useSoundManager';
import WaitingScreen from '../../components/waiting_screen';
import { HudManager } from '../../app/hud/hud_manager';
import { AutonomousStop } from '../../components/autonomousStop';
import { AutonomousWidgetManager } from '../../app/widget/autonomousWidgetManager';
import { DebugPanel } from '../../components/debugPanel';
import { FramePanel } from '../../components/framePanel';

const MapViewWrapper = lazy(() => import('../../app/map_view/mapViewWrapper'));

const LoadingFallback = () => (
	<div className='flex h-full items-center justify-center text-2xl font-bold'>
		Loading Map...
	</div>
);

export const DriverPage = () => {
	const version = useVersionStore();

	useUpdateLiveData();
	useSoundManager();

	if (!version.accepted) {
		return <WaitingScreen waitingText={'waiting for connection...'} />;
	}

	return (
		<>
			<Suspense fallback={<LoadingFallback />}>
				<MapViewWrapper />
			</Suspense>
			<HudManager />
			<AutonomousWidgetManager />
			<AutonomousStop />
		</>
	);
};
